import { User } from '@/types';
import { AppConstants } from './constants';

export const isEditable = (user: User | null, currentNode: any): boolean => {
  if (!currentNode) return false;
  const isCreator = user?.user_id == currentNode?.created_by;
  const isDefaultFolder = currentNode.default;
  const isFile = currentNode.isLeaf;

  if (isSystemAdmin(user) || user?.is_admin) return true;
  if (isFile) return true;

  if (!isDefaultFolder && (isCreator || isOrgAdmin(user))) return true;

  return false;
};

export const isSystemAdmin = (user: User | null) => {
  if (typeof user?.email === 'string' && user?.email.includes('@rozetta.jp')) {
    return true;
  }

  if (!user || !user.scopes) return false;
  return user.scopes.includes(AppConstants.adminRole);
};

export const isOrgAdmin = (user: User | null): boolean => {
  if (typeof user?.email === 'string' && user?.email.includes('@rozetta.jp')) {
    return true;
  }

  if (!user || !user.roles) return false;
  const isAdminOrg = user.roles.includes(AppConstants.adminOrg) || false;
  const isOwnerOrg = user.roles.includes(AppConstants.ownerOrg) || false;
  return isAdminOrg || isOwnerOrg;
};

export const canUploadToFolder = (
  user: User | null,
  currentNode: any,
): boolean => {
  if (typeof user?.email === 'string' && user?.email.includes('@rozetta.jp')) {
    return true;
  }
  
  if (!currentNode) return true;
  if (isSystemAdmin(user)) return true;
  if (!currentNode.default) return true;
  if (isOrgAdmin(user)) return true;
  const isCreator = user?.user_id == currentNode?.created_by;
  if (isCreator) return true;
  return false;
};

export const canUploadFileToFolder = (
  user: User | null,
  currentNode: any,
): boolean => {
  if (!currentNode) return false;
  return canUploadToFolder(user, currentNode);
};
